module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/4VjVYGuUBasYuUU060sIMG-a9785f37f38881d0309e6f6362a214e1.jpg";